"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.activitySchema = exports.goalsActivitySchema = exports.callActivitySchema = exports.chatActivitySchema = exports.activityUnstructuredContentSchema = exports.activityStructuredContentSchema = exports.baseActivitySchema = exports.activityMetadataSchema = exports.activityFormatEnum = exports.activityDisplaySchema = exports.activitySkillEnum = exports.activityDifficultyEnum = exports.activityStrategyEnum = exports.activityKindEnum = void 0;
const zod_1 = require("zod");
const activity_unstructured_1 = require("./activity.unstructured");
const answer_1 = require("./interactions/kinds/answer");
const session_1 = require("./session");
const voice_1 = require("./voice");
exports.activityKindEnum = zod_1.z.enum(["chat", "call", "goals"]);
exports.activityStrategyEnum = zod_1.z.enum(["structured", "unstructured"]);
exports.activityDifficultyEnum = zod_1.z.enum(["easy", "medium", "hard"]);
exports.activitySkillEnum = zod_1.z.enum([
    "vocabulary",
    "listening",
    "grammar",
    "pronunciation",
    "speaking",
    "reading",
    "writing",
]);
exports.activityDisplaySchema = zod_1.z.object({
    title: zod_1.z.string(),
    voice: voice_1.voiceSchema,
    backgroundUrl: zod_1.z.string(),
});
exports.activityFormatEnum = zod_1.z.enum([
    "ChatTestPronunciationChallenge",
    "ChatConsolidateLexisGrammarTeacher",
    "ChatTeachGrammarTeacher",
    "ChatTestLexisGrammarChallenge",
    "ChatIntroduceLexisTeacher",
    "ChatConsolidateLexisPronunciationActivity",
    "ChatTestListeningActivity",
    "VideoConsolidateLexisGrammarHelpers",
    "VideoTeachLexisPronunciationClassroom",
    "VideoIntroduceGrammarClassroom",
    "VideoIntroduceLexisEnglishInAction",
    "VideoConsolidateGrammarEnglishInAction",
    "GoalsConsolidateLexisGrammarActivity",
]);
exports.activityMetadataSchema = zod_1.z.object({
    difficulty: exports.activityDifficultyEnum,
    skill: exports.activitySkillEnum,
    format: exports.activityFormatEnum.nullish(),
    lastVideoGenerationAttempt: zod_1.z.string().nullish(),
});
exports.baseActivitySchema = zod_1.z.object({
    strategy: exports.activityStrategyEnum,
    moduleId: zod_1.z.string(),
    display: exports.activityDisplaySchema,
    metadata: exports.activityMetadataSchema,
    index: zod_1.z.number(),
    externalSourceId: zod_1.z.string(),
    externalSource: zod_1.z.literal("sheet"),
});
exports.activityStructuredContentSchema = zod_1.z.object({
    interactions: zod_1.z.array(session_1.sessionInteractionSchema),
    answers: zod_1.z.array(answer_1.answerSchema),
});
exports.activityUnstructuredContentSchema = zod_1.z.object({
    goals: zod_1.z.array(activity_unstructured_1.goalSchema),
    presentation: zod_1.z.object({
        title: zod_1.z.string(),
        description: zod_1.z.string(),
    }),
    situation: zod_1.z.string(),
    bot: zod_1.z.object({
        photoURL: zod_1.z.string(),
        persona: zod_1.z.string(),
    }),
});
exports.chatActivitySchema = exports.baseActivitySchema.merge(zod_1.z.object({
    kind: zod_1.z.literal("chat"),
    content: exports.activityStructuredContentSchema,
}));
exports.callActivitySchema = exports.baseActivitySchema.merge(zod_1.z.object({
    kind: zod_1.z.literal("call"),
    content: exports.activityStructuredContentSchema,
}));
exports.goalsActivitySchema = exports.baseActivitySchema.merge(zod_1.z.object({
    kind: zod_1.z.literal("goals"),
    content: exports.activityUnstructuredContentSchema,
}));
exports.activitySchema = zod_1.z.discriminatedUnion("kind", [
    exports.chatActivitySchema,
    exports.callActivitySchema,
    exports.goalsActivitySchema,
]);
//# sourceMappingURL=activity.js.map